import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@app/services/api.service';
import { Enums } from '@app/util/enums';

/**
 * service class to perform crud operations related to enum
 */
@Injectable({
  providedIn: 'root'
})
export class EnumService {

  /****************** Variable declaration ******************/
  public enumApis = this.apiService.ENUM_APIS
  public enumUrl = this.apiService.KPID_URL + this.enumApis.ENUM;

  /**
   * Constructor
   * @param httpClient 
   * @param apiService 
   */
  constructor(private httpClient: HttpClient,
    private apiService: ApiService) { }

  /**
  * fetch all the values of enum
  * 
  * @param enumName name of the enum
  * @returns values
  */
  allValues(enumName: Enums): Observable<any> {
    return this.httpClient.get(this.enumUrl + this.enumApis.ENUM_ALL(enumName));
  }
}
